(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9640],{

/***/ 44769:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ramp",
      function () {
        return __webpack_require__(6249);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6249:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ramp; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/components/Layout/Page.tsx + 1 modules
var Page = __webpack_require__(83559);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx + 5 modules
var src = __webpack_require__(8253);
;// CONCATENATED MODULE: ./src/views/Ramp/Ramp.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  padding: 15px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  --border-radius: 10px;\n  box-shadow: 0 2px 10px 0 rgba(0,0,0,.20);\n  border-radius: var(--border-radius);\n  margin: auto;\n  max-width: 420px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-31b112bd-0"
})(_templateObject());
var StyledIframe = styled_components_browser_esm/* default.iframe.withConfig */.ZP.iframe.withConfig({
    componentId: "sc-31b112bd-1"
})(_templateObject1());
var Ramp = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIframe, {
                    src: "https://widget.onramper.com?color=266677&apiKey=pk_prod_i9g131xvRdAEsa7sUXcWkgEHEPTCQbUDox7SOZcjKbw0",
                    height: "660px",
                    width: "482px",
                    title: "Onramper widget",
                    allow: "accelerometer; autoplay; camera; gyroscope; payment"
                })
            })
        })
    });
};
/* harmony default export */ var Ramp_Ramp = (Ramp);

;// CONCATENATED MODULE: ./src/views/Ramp/index.ts


;// CONCATENATED MODULE: ./src/pages/ramp.tsx

/* harmony default export */ var ramp = (Ramp_Ramp);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(44769); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);